import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import ClientOAuth2 from 'client-oauth2'

import App from './App.vue'
import Connect from './components/Connect.vue'
import Upload from './components/Upload.vue'
import About from './components/About.vue'
import Uploads from './components/Uploads.vue'
import Account from './components/Account.vue'
import Loader from './components/Loader.vue'
import config from './config.json'

import './registerServiceWorker'

Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(ElementUI)

Vue.config.productionTip = false

const zenodoAuth = new ClientOAuth2({
  clientId: config.client_ID,
  accessTokenUri: config.access_token_url,
  authorizationUri: config.authorize_url,
  redirectUri: `${location.origin}/waiting`, // eslint-disable-line no-restricted-globals
  scopes: ['deposit:write', 'deposit:actions'],
})

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/connect', component: Connect, props: { zenodoAuth } },
    { path: '/upload/list', component: Uploads, props: { zenodoAuth } },
    { path: '/upload/:id', component: Upload, props: { zenodoAuth } },
    { path: '/about', component: About, props: { zenodoAuth } },
    { path: '/account/:first?', component: Account, props: { zenodoAuth } },
    { path: '/waiting', component: Loader, props: { zenodoAuth } },
    { path: '/', redirect: '/waiting' },
  ],
})

new Vue({
  router,
  render: h => h(App, {
    props: {
      zenodoAuth,
    },
  }),
}).$mount('#app')
